export const RedXIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1387_9379)">
        <path
          d="M10.25 20.4932C15.7728 20.4932 20.25 16.019 20.25 10.4998C20.25 4.98056 15.7728 0.506348 10.25 0.506348C4.72715 0.506348 0.25 4.98056 0.25 10.4998C0.25 16.019 4.72715 20.4932 10.25 20.4932Z"
          fill="#E21B1B"
        />
        <path
          d="M7.07778 5.78062L5.53125 7.32715L13.4217 15.2176L14.9683 13.6711L7.07778 5.78062Z"
          fill="white"
        />
        <path
          d="M13.4217 5.78041L5.53125 13.6709L7.07778 15.2174L14.9683 7.32694L13.4217 5.78041Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1387_9379">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.25 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
